import { render, staticRenderFns } from "./TextFieldUniqueDepartmentNumber.vue?vue&type=template&id=21e7ba6e"
import script from "./TextFieldUniqueDepartmentNumber.vue?vue&type=script&lang=js"
export * from "./TextFieldUniqueDepartmentNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports